export default __webpack_public_path__ + "static/media/mentorship_icon.cbca722a.png";